import React from 'react'
import { Typography, Grid, Rating, Box, SvgIcon } from '@hermes/web-components'
import useTranslateMessage from '../../../../hooks/useTranslateMessage'
import {
  RatePaperMobileTypography,
  StyledDivider,
  StyledGridForPaper,
  StyledPaper
} from './SearchProfileCardMobileForced.styles'
import TrustRatingStatisticSearch from './TrustRatingStatisticSearch'

const iconStyles = { width: '20px', height: '20px', color: 'system.navy900' }

const RatePaperMobile = ({
  profileReviewTotal,
  peerRecommendationsCount,
  averageRating,
  yearsOfExperienceValue,
  location,
  treatments,
  children,
  isPractice
}: {
  profileReviewTotal: number
  peerRecommendationsCount?: number
  averageRating?: number
  yearsOfExperienceValue: number | null
  location: string
  treatments: React.ReactNode[]
  children: any
  isPractice: boolean
}) => {
  const translate = useTranslateMessage()

  return (
    <StyledGridForPaper width="100%">
      <StyledPaper className="rate-paper-container" isProfileReviewsPresent={profileReviewTotal > 0}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            height: '100%'
          }}
        >
          <Box
            sx={{
              gap: '12px',
              display: 'flex',
              flexDirection: 'column',
              pb: '16px'
            }}
          >
            <Grid item container gap="8px" sm={12} alignItems="center">
              <Box display="flex" alignItems="flex-end">
                <Typography
                  fontWeight="500"
                  fontFamily="Poppins"
                  fontSize="24px"
                  lineHeight="32px"
                  color="text.darkNavy"
                >
                  {averageRating ? averageRating?.toFixed?.(2) : '-'}
                </Typography>
                <Typography
                  fontWeight="500"
                  fontFamily="Poppins"
                  fontSize="13px"
                  lineHeight="32px"
                  color="text.darkNavy"
                >
                  /5
                </Typography>
              </Box>
              <Rating
                value={Number(averageRating) || 0}
                size="small"
                sx={{ fontSize: 16, height: 'fit-content' }}
                readOnly
              />
              {!!profileReviewTotal && (
                <Box display="flex" flexDirection="row" height={'fit-content'}>
                  <TrustRatingStatisticSearch count={profileReviewTotal || 0} name={translate('reviews_one')} />
                </Box>
              )}
            </Grid>
            {!isPractice && !!peerRecommendationsCount && (
              <Grid item container gap="12px" alignItems="flex-start" wrap="nowrap">
                <Box display="flex" alignItems="flex-end">
                  <SvgIcon sx={iconStyles} viewBox="0 0 20 20">
                    <use href="#pen-icon" />
                  </SvgIcon>
                </Box>
                <RatePaperMobileTypography>{`${peerRecommendationsCount} ${translate('search.peer_endorsements', {
                  count: peerRecommendationsCount || 0
                })}`}</RatePaperMobileTypography>
              </Grid>
            )}
            {!!yearsOfExperienceValue && !isPractice && (
              <Grid item container gap="12px" alignItems="flex-start" wrap="nowrap">
                <Box display="flex" alignItems="flex-end">
                  <SvgIcon sx={iconStyles}>
                    <use href="#person-with-shield-icon" />
                  </SvgIcon>
                </Box>
                <RatePaperMobileTypography>
                  {translate('search.profileCard.badge.yearsOfExperience', {
                    years: yearsOfExperienceValue
                  })}
                </RatePaperMobileTypography>
              </Grid>
            )}
            {!!location && (
              <Grid item container gap="12px" alignItems="flex-start" wrap="nowrap">
                <Box display="flex" alignItems="flex-end">
                  <SvgIcon stroke="currentColor" sx={iconStyles} viewBox="0 0 16 18">
                    <use href="#location-pin-icon" />
                  </SvgIcon>
                </Box>
                <RatePaperMobileTypography>{location}</RatePaperMobileTypography>
              </Grid>
            )}
            {!!treatments.length && (
              <Grid item container gap={'8px'} sm={12} sx={{ width: '100%' }} alignItems="center">
                {treatments}
              </Grid>
            )}
          </Box>
          {!!children && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}
            >
              <Grid item container gap={'8px'} sm={12} alignItems="center">
                <StyledDivider />
              </Grid>
              {children}
            </Box>
          )}
        </Box>
      </StyledPaper>
    </StyledGridForPaper>
  )
}

export default RatePaperMobile
